import api from 'api'

export type CustomShiftNotification = {
  id: number
  deliveryHour: number
  title?: string | null
  message?: string | null
}

export type GetCustomShiftNotificationsResponse = {
  notifications: CustomShiftNotification[]
}

export async function getCustomShiftNotifications(shiftId: number) {
  const response = await api.get<GetCustomShiftNotificationsResponse>(
    `/admin/shift/${shiftId}/custom_notifications`
  )
  return response.data
}
